import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const AlertError = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 24, height: 24, fill: 'none', ...props.sx }}
    data-testid="alertErrorIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.9999 17.4C12.7025 17.4 13.272 16.8305 13.272 16.1279C13.272 15.4253 12.7025 14.8558 11.9999 14.8558C11.2973 14.8558 10.7278 15.4253 10.7278 16.1279C10.7278 16.8305 11.2973 17.4 11.9999 17.4ZM10.7278 7.87212C10.7278 8.34674 10.7319 12.8827 11.9999 12.8827C13.2679 12.8827 13.272 8.34674 13.272 7.87212C13.272 7.16955 12.7025 6.6 11.9999 6.6C11.2973 6.6 10.7278 7.16955 10.7278 7.87212Z"
      fill="#D52B1E"
    />
  </SvgIcon>
);

export default AlertError;
